import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import { TColor } from "../../types";
import Flex from "../Flex/Flex";
import Typography from "../Typography/Typography";
import { BaseMenuItem } from "./BaseMenuItem";

type Props = React.ComponentProps<typeof BaseMenuItem>;
type Story = GenericStory<Props>;
type BoxProps = { $bg: TColor };

export default {
    title: "common/CustomNavigationMenuItem",
    component: BaseMenuItem
} as ComponentMeta<typeof BaseMenuItem>;

const Box = ({ $bg }: BoxProps) => {
    return (
        <Flex
            alignItems="center"
            backgroundColor={$bg}
            borderColor={$bg}
            borderRadius={8}
            borderStyle="solid"
            borderWidth={1}
            justifyContent="center"
            column
            height={800}
            style={{ scrollMarginTop: 16 }}
        >
            <Typography color="surface-1200" variant="label-medium-semibold">
                Click the menu item to change the background color
            </Typography>
        </Flex>
    );
};

const Template: Story = args => {
    const [bg, setBg] = React.useState<TColor>("surface-100");
    const handleClick = () => {
        bg === "surface-100" ? setBg("surface-300") : setBg("surface-100");
    };

    return (
        <Flex alignItems="flex-start" gap={16}>
            <BaseMenuItem {...args} handleItemClick={handleClick} />

            <Flex column grow={1}>
                <Box $bg={bg} />
            </Flex>
        </Flex>
    );
};

export const Default = Template.bind({});
Default.args = {
    active: true,
    elementId: "first",
    title: "First section"
};
